// Wizard step 4 / the record's contact editor (S4.1, S4.2, decision 15).
// First Name, Last Name and Email are the only required fields — Mobile/Phone, Job Title and Site
// Access are all optional. The Imperans role is required in the wizard and optional on the record,
// so its rule is applied by the form, not declared here.
export const fields = {
  companyContactID: {},
  firstName: {
    label: "First Name",
    rules: "required|string",
  },
  lastName: {
    label: "Last Name",
    rules: "required|string",
  },
  emailAddress: {
    label: "Email",
    rules: "required|email",
  },
  jobTitle: {
    label: "Job Title",
  },
  phoneNumber: {
    label: "Mobile / Phone Number",
  },
  officeNumber: {
    label: "Office Number",
  },
  staffPrimaryOfficeAddress: {
    label: "Address",
  },
  vendorTypeID: {
    label: "TDDA/Health Tick",
    rules: "required",
    value: [],
  },
  /** Customer Admin / Customer Drug Test Results / Customer Bookings (S4.1). */
  imperansRoleID: {
    label: "Imperans Role",
  },
  /** Held as one contact per client — setting it clears every other (S4.2). */
  isPrimaryContact: {
    label: "Main contact",
    value: false,
  },
  isRequestingTestPersonnel: {
    // Matches every other surface — the blocking message, step 6's review block and the SOP all
    // already said "Report to Person (RTP)", the acceptance criteria's own term (task 5852). This
    // was the one screen still saying "Requesting Test Personnel (RTP)".
    label: "Report to Person (RTP)",
    value: false,
  },
  hasResultsAccess: {
    label: "Results Access",
    value: false,
  },
  isPointOfContact: {
    label: "Point of Contact",
    value: false,
  },
  isSafetyCritical: {
    label: "Safety Critical",
    value: false,
  },
};
